var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('IconBase',{attrs:{"name":_vm.name,"size":40,"color":_vm.iconView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }